export const Types = {
  SAVE_LIST_USER_ADMIN: 'SAVE_LIST_USER_ADMIN',
  SAVE_DETAIL_ADMIN: 'SAVE_DETAIL_ADMIN'
}
